<template>
  <el-dropdown>
  <span class="el-dropdown-link">
    {{$t('feed.actions.title')}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
    <el-dropdown-menu>
      <el-dropdown-item>
          <router-link
            :to="{ name: 'feedSettings', params: { threadId: threadId }}"
            class="action-feed__link"
          >
          <i class="el-icon-s-tools"></i> {{$t('feed.actions.items[0]')}}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item v-if="status === 'pause'" @click.native="toggleLaunch">
        <i class="el-icon-video-play"></i> {{$t('feed.actions.items[1]')}}
      </el-dropdown-item>
      <el-dropdown-item v-else @click.native="toggleLaunch">
        <i class="el-icon-video-pause" ></i> {{$t('feed.actions.items[2]')}}
      </el-dropdown-item>
      <el-dropdown-item v-if="published" @click.native="unpublishFeed">
        <i class="el-icon-files"></i> В архив
      </el-dropdown-item>
      <el-dropdown-item v-else @click.native="publishFeed">
        <i class="el-icon-files"></i> Вернуть из архива
      </el-dropdown-item>
      <el-dropdown-item divided @click.native="deleteFeed">
        <i class="el-icon-delete-solid"></i> {{$t('feed.actions.items[3]')}}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

  export default {
    name: 'FeedActions',
    data(){
      return {
        published: true,
      }
    },
    props: ['threadId', 'feedName', 'status'],
    methods: {
      deleteFeed() {
        this.$alert(`Удалить ленту ${this.feedName}?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.$emit('handleFeedDelete', this.threadId);
            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      unpublishFeed() {
        this.$alert(`Отправить в архив ленту ${this.feedName}?`, 'В архив', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.$emit('handleFeedUnpublished', this.threadId);
            } else {
              this.$message({
                type: 'info',
                message: `отменено`
              });
            }
          }
        });
      },
      publishFeed() {
        this.$alert(`Вернуть из архива ленту ${this.feedName}?`, 'Вернуть', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.$emit('handleFeedPublished', this.threadId);
            } else {
              this.$message({
                type: 'info',
                message: `отменено`
              });
            }
          }
        });
      },
      toggleLaunch() {
        this.$emit('toggleLaunch', {threadId: this.threadId, status: this.status});
      },
    },
    beforeMount() {
      this.published = this.$store.getters.published
    },
  };
</script>

<style>
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

  .action-feed__link,
  .action-feed__link:visited {
    display: inline-block;
    margin-bottom: 10px;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
    text-decoration: none;
  }

  .action-feed__link:hover,
  .action-feed__link:focus,
  .action-feed__link:active {
    color: #1989fa;
  }
</style>
